export default __webpack_public_path__ + "static/media/invisible-icon.b81d775b.svg";